import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { FormattedMessage, injectIntl } from 'react-intl';
import { spotlightElement } from '../../lib/findBobUtils';
import { generatedHeadlineForUser, generatedBioForUser, generatedRjHeadlineForUser } from '../../lib/userUtils';
import { STEP_NUMBERS } from './SignUpWizard';
import LoadingButtonWrapper from '../LoadingButtonWrapper/LoadingButtonWrapper';
import AIHeadline from '../AiHeadline/AiHeadline';

const UpdateCurrentUser = gql`
  mutation updateCurrentUser($headline: String, $bio: String, $ask_me_about: String) {
    updateCurrentUser(headline: $headline, bio: $bio, ask_me_about: $ask_me_about)
  }
`;

const styles = () => ({
  formGroup           : {
    border       : '1px solid #dadada',
    padding      : '12px',
    marginTop    : '6px',
    borderRadius : '2px',
  },
  groupTitle          : {
    paddingLeft : '6px',
  },
  rjpeBackgroundColor : {
    backgroundColor : '#002949',
    '&:hover'       : {
      background : '#424949',
    },
  },
  ppiBackgroundColor  : {
    backgroundColor : '#7399c6',
    '&:hover'       : {
      background : '#949ca',
    },
  },
});

class UserBio extends React.Component {
  state = {};

  componentWillMount () {
    setTimeout(this.generateHeadline, 200);
  }
  generateHeadline = () => {
    const {
      headline,
      user,
      updateAction,
      intl,
      companyHasCounty,
      countryForCompany,
      agentWord,
      locale,
      companyBusinessType,
    } = this.props;
    let generateHeadline = '';
    if(locale !== 'fr') {
      if (companyBusinessType === 'wealth_rj') {
        generateHeadline = generatedRjHeadlineForUser(user, intl, companyHasCounty, countryForCompany, agentWord);
      } else {
        generateHeadline = generatedHeadlineForUser(user, intl, companyHasCounty, countryForCompany, agentWord);
      }
    }

    if (headline === null) {
      this.setState({
        headline : generateHeadline,
      }, () => {
        updateAction({
          headline : user.headline || generateHeadline,
          bio      : user.bio || generatedBioForUser(user),
        });
      });
    } else {
      this.setState({
        headline : headline || generateHeadline,
      });
    }
  }

  updateUser = () => {
    const { mutate, onNext, updateAction } = this.props;
    const { headline, ask_me_about } = this.state;
    updateAction({ loading: true });
    mutate({
      variables : {
        headline,
        ask_me_about,
      },
    })
      .then(() => {
        onNext(STEP_NUMBERS.complete);
        updateAction({ loading: false });
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log('there was an error sending the query', error);
        updateAction({ loading: false });
      });
  };

  validate = () => {
    const { alterItems, askMeAboutMandatory } = this.props;
    const { headline, ask_me_about } = this.state;
    if (alterItems && askMeAboutMandatory) {
      return headline && ask_me_about;
    }
    return headline;
  };

  render () {
    const {
      updateAction,
      onBack,
      classes,
      stylesheetName,
      alterItems,
      show_ask_about_me,
      askMeAboutMandatory,
      user,
      features,
    } = this.props;
    const { headline } = this.state;
    return (
      <div className="content">
        <h2>
          <FormattedMessage id="sign_up_pages.last_but_not_least" />
        </h2>
        <b>
          <FormattedMessage id="sign_up_pages.headline" />
        </b>
        <p>
          {user.is_student 
            ? <FormattedMessage id="sign_up_pages.student_headline_subtitle" />
            : <FormattedMessage id="sign_up_pages.headline_subtitle" />
          }
        </p>
        <div onMouseOver={e => spotlightElement('.headline')}>
          {features && !features.includes('ai_headlines') ? (
          <TextareaAutosize
            placeholder={headline}
            value={headline}
            shouldFitContainer
            autoFocus
            minRows={4}
            isSpellCheckEnabled
            isLabelHidden
            multiline
            key="headline"
            style={{ width: '100%' }}
            onChange={e => {
              this.setState({ headline: e.target.value });
              updateAction({ headline: e.target.value });
            }}
          />)
          :
          <AIHeadline
            headline={headline}
            updateHeadline={headline => { updateAction({ headline }); this.setState({ headline }); }}
            stylesheetName={stylesheetName}></AIHeadline>
          }
          
          {/* AI Privacy & Security Disclaimer */}
          {features && features.includes('ai_headlines') && (
            <div style={{ 
              marginTop: '16px',
              padding: '12px', 
              backgroundColor: '#f5f5f5', 
              borderLeft: '4px solid #ff9800',
              borderRadius: '4px'
            }}>
              <p style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '14px' }}>
                AI Privacy & Security
              </p>
              <p style={{ fontSize: '14px', lineHeight: '1.5', margin: 0 }}>
                Our AI features are designed with privacy, security, and fairness in mind. Client data is never used to train external AI models, and all use of AI complies with applicable privacy, confidentiality, and information security requirements. Please always review the details for accuracy and suitability as outputs may contain mistakes.
              </p>
            </div>
          )}
        </div>
        {alterItems &&
        show_ask_about_me && (
          <div>
            <br />
            <b><FormattedMessage id="sign_up_pages.ask_me_about" /></b>
            <p>
              <FormattedMessage id="sign_up_pages.ask_me_about_subtitle" />
            </p>
            <div>
              <TextareaAutosize
                shouldFitContainer
                autoFocus
                minRows={4}
                isSpellCheckEnabled
                isLabelHidden
                multiline
                key="headline"
                style={{ width: '100%' }}
                onChange={e => {
                  this.setState({ ask_me_about: e.target.value });
                  updateAction({ ask_me_about: e.target.value });
                }}
              />
              <p>
                <FormattedMessage id="sign_up_pages.click_below_to_complete" />
              </p>
            </div>
          </div>
        )}
        <br />
        <br />
        <div className="text-center">
          {onBack && (
            <button
              type="button"
              className={'btn btn-default'}
              style={{ padding: '12px 24px', float: 'left', color: '#fff' }}
              onClick={onBack}>
              <FormattedMessage id="sign_up_pages.back" />
            </button>
          )}
          <LoadingButtonWrapper stateChild="user">
            <button
              type="button"
              onClick={this.updateUser}
              className={'btn btn-default'}
              style={{ padding: '12px 24px', float: 'right', color: '#fff' }}
              disabled={!this.validate()}>
              <FormattedMessage id="sign_up_pages.next" />
            </button>
          </LoadingButtonWrapper>
        </div>
      </div>
    );
  }
}

UserBio.propTypes = {
  headline          : PropTypes.string,
  countryForCompany : PropTypes.string,
  agentWord         : PropTypes.string,
  locale            : PropTypes.string,
  user              : PropTypes.object,
  updateAction      : PropTypes.func.isRequired,
  mutate            : PropTypes.func.isRequired,
  onNext            : PropTypes.func.isRequired,
  intl              : PropTypes.object.isRequired,
  companyHasCounty  : PropTypes.bool,
  onBack            : PropTypes.func,
};

UserBio.defaultProps = {
  headline          : null,
  user              : {},
  companyHasCounty  : false,
  countryForCompany : 'ca',
  agentWord         : '',
  locale            : 'en',
  onBack            : null,
};

const StyledTextField = styled(TextField)`
  && .MuiInput-underline:after {
    border-color: #002949 !important;
  }
`;

const UserBioWithStyles = injectIntl(withStyles(styles)(UserBio));
export default graphql(UpdateCurrentUser)(UserBioWithStyles);
